import { startRegistration } from '@simplewebauthn/browser';
export function getPasskeyHttpStatus(error) {
    const status = error?.response?.status;
    return typeof status === 'number' ? status : undefined;
}
export async function registerPasskeyWithIdp(api) {
    const data = await api.beginPasskeyRegistration();
    const optionsJSON = data.optionsJSON ?? data.options;
    if (!optionsJSON) {
        throw new Error('Passkey registration options missing from server response.');
    }
    const attestation = await startRegistration({
        optionsJSON: optionsJSON,
    });
    await api.verifyPasskeyRegistration({
        challengeId: data.challengeId,
        response: attestation,
    });
}
//# sourceMappingURL=passkeyRegistration.js.map